import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col } from 'antd';
import { Modal } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import Format from '../../utils/format';
import * as SignalR from '@aspnet/signalr';

const confirmAlert = Modal.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
  'templateStore',
  'CmsLanguageStore',
  'webSettingStore',
  'CmsMenuStore'
)
@observer
class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
    this.props.templateStore.getActive();

    this.props.CmsMenuStore.getActives().then(() => {
      console.log('=== CmsMenuStore.activeMenus ===', JSON.parse(JSON.stringify(this.props.CmsMenuStore.data)));
    });

    let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
    connection.start().catch(function (err) { return console.error(err.toString()); });
    connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
  }

  componentWillUnmount() {
  }

  // ON CLICK

  menuSoonClick = () => {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSetting } = this.props.webSettingStore;
    confirmAlert('',
      <div
        style={{
          fontFamily: activeTemplate.templateSetting.text.fontFamily,
          color: activeTemplate.templateSetting.text.color,
          fontSize: activeTemplate.templateSetting.text.fontSize,
          lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
          textAlign: 'center'
        }}
      >
        <span>Available Soon</span>
      </div>,
      [
        {
          text: webSetting.okText
        }
      ]);
  }

  menuClick = (taskID, menuType, isSoon, redirectUrl) => {
    const {
      activeLanguages
    } = this.props.CmsLanguageStore;

    const lang = window.localStorage.getItem('lang') || 'en';
    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    if (isSoon) {
      this.menuSoonClick();
    } else {
      switch (menuType) {
        case 'AMENITY':
          this.props.history.push(`amenity`);
          break;

        case 'HK_SERVICE':
        case 'CONCIERGE':
        case 'DEFECT_REPORT':
        case 'DND':
        case 'FRONT_OFFICE':
        case 'LATE_CHECKOUT':
          this.props.history.push(`single-list/${taskID}/language/${languageId}`);
          break;

        case 'BOOKING_FACILITY':
          this.props.history.push(`booking`);
          break;

        case 'IN_ROOM_DINING':
          this.props.history.push(`fnb`);
          break;

        case 'IN_ROOM_DINING_URL':
          if (redirectUrl) {
            window.open(redirectUrl, '_blank');
          } else {
            console.warn('Redirect URL is not configured for this menu');
          }
          break;

        case 'LAUNDRY':
          this.props.history.push(`laundry`);
          break;

        case 'PRINT_FILE':
          this.props.history.push(`print-file`);
          break;

        case 'RCU_CONTROL':
          this.props.history.push(`rcu-control`);
          break;

        case 'SHOPPING':
          this.props.history.push(`shopping`);
          break;

        case 'SPA':
          this.props.history.push(`spa`);
          break;

        case 'TRANSPORTATION':
          this.props.history.push(`transportation`);
          break;

        case 'TV_CHANNEL':
          this.props.history.push(`tv-channel`);
          break;

        case 'WAKE_UP_CALL':
          this.props.history.push(`wakeup-call`);
          break;

        default:
          break;
      }
    }
  }

  // ON RENDER

  getCheckinTimeOnRender = () => {
    let checkinTime = localStorage.getItem('checkinTime');

    if (checkinTime) {
      if (checkinTime !== 'null') {
        return checkinTime.replace(/^"(.*)"$/, '$1');
      }
    }

    return '-';
  }

  getCheckoutTimeOnRender = () => {
    let checkoutTime = localStorage.getItem('checkoutTime');

    if (checkoutTime) {
      if (checkoutTime !== 'null') {
        return checkoutTime.replace(/^"(.*)"$/, '$1');
      }
    }

    return '-';
  }

  render() {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSettting } = this.props.webSettingStore;
    const showHeaderFooter = localStorage.getItem('showHeaderFooter');
    const checkinTime = this.getCheckinTimeOnRender();
    const checkoutTime = this.getCheckoutTimeOnRender();
    const lang = window.localStorage.getItem('lang') || 'en';
    const todayLang = Format.DateTimeDayLocale(new Date());
    const roomNo = JSON.parse(localStorage.getItem('roomNo'));
    const { data: activeMenus } = this.props.CmsMenuStore;
    const { activeLanguages } = this.props.CmsLanguageStore;

    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    // 菜单分组：每行固定2个
    const perRow = 2;
    const completeMenus = activeMenus.slice(0, activeMenus.length - (activeMenus.length % perRow));
    const lastMenu = activeMenus.length % perRow !== 0 ? activeMenus[activeMenus.length - 1] : null;
    const menuRows = [];
    for (let i = 0; i < completeMenus.length; i += perRow) {
      menuRows.push(completeMenus.slice(i, i + perRow));
    }

    return (
      <>
        {
          activeTemplate
            ?
            <>
              {/* Header & Menu */}
              {
                webSettting
                  ?
                  <>
                    <Row className={'stm-width-100-percent'} style={{ backgroundColor: '#FAFAFA' }}>
                      <Col
                        span={24}
                        className='stm-width-100-percent stm-height-auto stm-padding-10-20 stm-background-size-cover'
                      >
                         {lastMenu && (() => {
                                  const taskLang = lastMenu.taskLanguages.find(fi => fi.langID === languageId);
                                  return (
                                    <Row style={{ display: 'flex', flexWrap: 'nowrap' }}>
                                      <Col key={`card-${lastMenu.id || lastMenu.taskID}`} span={24} style={{ display: 'flex' }}>
                                        <div
                                          className='stm-position-relative stm-border-radius-6'
                                          style={{
                                            backgroundColor: 'white',
                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                            padding: '12px',
                                            cursor: 'pointer',
                                            flex: 1,
                                            margin: '4px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            border: '1px solid #B3B3B3',
                                          }}
                                          onClick={(e) => {
                                                  e.stopPropagation();
                                                  this.props.history.push(`/home-select-service?taskId=${lastMenu.taskID}`);
                                                }}
                                        >
                                          {/* Soon Badge */}
                                          {
                                            lastMenu.isSoon
                                              ?
                                              <div className='stm-menu-soon'>{webSettting.soonText}</div>
                                              :
                                              null
                                          }

                                          {/* Left: Icon */}
                                          <img
                                            src={lastMenu.imageUrl}
                                            alt='iconUrl'
                                            style={{ width: '40px', height: '40px', marginRight: '10px', flexShrink: 0 }}
                                          />

                                          {/* Middle: Title + Description */}
                                          <div style={{ flex: 1, minWidth: 0 }}>
                                            <div
                                              style={{
                                                fontWeight: '600',
                                                fontSize: activeTemplate.templateSetting.menu.fontSize,
                                                fontFamily: activeTemplate.templateSetting.menu.fontFamily,
                                                color: activeTemplate.templateSetting.menu.color,
                                                lineHeight: `${activeTemplate.templateSetting.menu.fontSize + 4}px`,
                                                marginBottom: taskLang && taskLang.taskLangDescription ? '4px' : 0,
                                              }}
                                            >
                                              {taskLang ? taskLang.taskLangName : ''}
                                            </div>
                                            {taskLang && taskLang.taskLangDescription ? (
                                              <div
                                                className='stm-task-description'
                                                style={{
                                                  fontSize: '12px',
                                                  fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                  color: '#888',
                                                  lineHeight: '1.4',
                                                  overflowWrap: 'break-word',
                                                }}
                                              >
                                                <div dangerouslySetInnerHTML={{ __html: taskLang.taskLangDescription }} />
                                              </div>
                                            ) : null}
                                          </div>

                                          {/* Right: Arrow */}
                                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, marginLeft: '8px' }}>
                                            <path d="M9 6L15 12L9 18" stroke="#181818" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                          </svg>
                                        </div>
                                      </Col>
                                    </Row>
                                  );
                                })()}
                        <Row style={{ display: 'flex', alignItems: 'center', paddingBottom: '5px' }}>
                          <Col
                            span={24}
                            className='stm-font-weight-bold'
                            style={{
                              fontFamily: activeTemplate?.templateSetting.label.fontFamily,
                              fontSize: 18,
                            }}
                          >
                            Services
                          </Col>
                          {/* <Col span={12} className='stm-text-align-right'>
                            <span className="stm-most-popular-badge">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                              </svg>
                              Most Popular
                            </span>
                          </Col> */}
                        </Row>
                        {/* Menu List */}
                        {/* 单数最后一张占满整行 */}
                        {/* 完整行：每行两个卡片 */}
                        {menuRows.map((rowMenus, rowIdx) => (
                                  <Row key={`menu-row-${rowIdx}`} style={{ display: 'flex', flexWrap: 'nowrap' }}>
                                    {rowMenus.map((menu) => {
                                      const taskLang = menu.taskLanguages.find(fi => fi.langID === languageId);
                                      return (
                                        <Col key={`card-${menu.id || menu.taskID}`} span={12} style={{ display: 'flex' }}>
                                          <div
                                            className='stm-position-relative stm-border-radius-6'
                                            style={{
                                              backgroundColor: 'white',
                                              padding: '12px',
                                              cursor: 'pointer',
                                              flex: 1,
                                              margin: '4px',
                                              overflow: 'hidden',
                                              display: 'flex',
                                              flexDirection: 'column',
                                              border: '1px solid #B3B3B3',
                                            }}
                                          >
                                            {/* Soon Badge */}
                                            {
                                              menu.isSoon
                                                ?
                                                <div className='stm-menu-soon'>{webSettting.soonText}</div>
                                                :
                                                null
                                            }

                                            {/* Card Content: Icon left + Text right */}
                                            <div style={{ display: 'flex', alignItems: 'flex-start', flex: 1 }}>
                                              {/* Left: Icon */}
                                              <div style={{ marginRight: '10px', flexShrink: 0 }}>
                                                <img
                                                  src={menu.imageUrl}
                                                  alt='iconUrl'
                                                  style={{ width: '50px', height: '50px' }}
                                                />
                                              </div>

                                              {/* Right: Title + Description */}
                                              <div style={{ flex: 1, minWidth: 0 }}>
                                                {/* Title */}
                                                <div
                                                  style={{
                                                    fontWeight: '600',
                                                    fontSize: activeTemplate.templateSetting.menu.fontSize,
                                                    fontFamily: activeTemplate.templateSetting.menu.fontFamily,
                                                    color: activeTemplate.templateSetting.menu.color,
                                                    marginBottom: '4px',
                                                    lineHeight: `${activeTemplate.templateSetting.menu.fontSize + 4}px`,
                                                    wordBreak: 'break-word',
                                                  }}
                                                >
                                                  {taskLang ? taskLang.taskLangName : ''}
                                                </div>

                                                {/* Description */}
                                                <div
                                                  className='stm-task-description'
                                                  style={{
                                                    fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                    fontSize: '12px',
                                                    color: '#888',
                                                    lineHeight: '1.4',
                                                    overflowWrap: 'break-word',
                                                  }}
                                                >
                                                  {taskLang && taskLang.taskLangDescription ? (
                                                    <div dangerouslySetInnerHTML={{ __html: taskLang.taskLangDescription }} />
                                                  ) : null}
                                                </div>
                                              </div>
                                            </div>

                                            {/* View All Button — 固定在底部右下 */}
                                            <div style={{ textAlign: 'right', marginTop: '8px' }}>
                                              <span
                                                style={{
                                                  fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                  display: 'inline-block',
                                                  padding: '2px 16px',
                                                  border: '1px solid #333',
                                                  borderRadius: '16px',
                                                  fontSize: '12px',
                                                  fontWeight: 600,
                                                  color: '#333',
                                                  cursor: 'pointer',
                                                }}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  this.props.history.push(`/home-select-service?taskId=${menu.taskID}`);
                                                }}
                                              >
                                                View All
                                              </span>
                                            </div>
                                          </div>
                                        </Col>
                                      );
                                    })}
                                  </Row>
                                ))}


                      </Col>
                    </Row>
                  </>
                  :
                  null
              }
            </>
            :
            null
        }
      </>
    )
  }
}

export default withTranslation()(Home)
